import React from 'react'
import * as UIcons from '@iconscout/react-unicons'
import { withTranslation } from 'react-i18next'
import Btn from 'components/Btn'
import { withRouter } from 'hooks/withRouter'

export default withTranslation()(withRouter(function Offline({ t, router }) {

  return (
    <div className="w-11/12 mx-auto pt-24 py-12 flex h-screen">
      <div className="m-auto text-center flex items-center flex-col">
        <div className="h-20 w-20 flex rounded-full bg-white text-primary mb-4">
          <UIcons.UilWifiSlash className="m-auto h-14 w-14" />
        </div>
        <h3 className="text-3xl font-bold mb-3">{ t('misc.offline.title') }</h3>
        <p className="text-lg">{ t('misc.offline.body') }</p>

        <div className="w-32 h-10 overflow-hidden">
          <Btn 
            content={t('misc.reload')}
            className="w-32 h-10 text-white mt-8 bg-[rgba(25, 118, 210)]"
            click={() => router.navigate('/overview')}
          />
        </div>
      </div>
    </div>
  )
}))
